export default __webpack_public_path__ + "static/media/Dayanand Sagar.6e44bb8b.png";